import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as LocalStorage from "../../utils/localStorage";
import {
  deleteProductCategory,
  showAddCategoryAction,
} from "../redux/actions/productsActions";
import { FaTrash } from "react-icons/fa";
import styles from "./productsStyles.module.css";
import AddNewCategory from "./addCategory";

const ProductCatSection = () => {
  const actionDispatch = useDispatch();
  const productsListColumns = [
    { key: "Product Categories", label: "categories" },
    { key: " ", label: "delete" },
  ];
  const { data: productsData, showAddCategory } = useSelector(
    (state) => state.products
  );

  const deleteCurrentCategory = (row) => {
    const newCategories = productsData.categories.filter(
      (productCategory) => productCategory !== row
    );
    LocalStorage.setLSValue("productsData", {
      ...productsData,
      categories: newCategories,
    });
    actionDispatch(
      deleteProductCategory(LocalStorage.getLSValue("productsData"))
    );
  };

  const addCategory = () => {
    if (!showAddCategory) {
      actionDispatch(showAddCategoryAction(true));
    }
  };
  return (
    <section id={styles.productsCatSection}>
      <div id={styles.productsCatDiv}>
        <table className={styles.categoriesTable} key="categoriesTable">
          <thead>
            <tr>
              {productsListColumns.map((column, index) => {
                return <td key={`${column.key} ${index}`}>{column.key}</td>;
              })}
            </tr>
          </thead>
          <tbody>
            {productsData.categories.map((row, index) => {
              return (
                <tr key={index}>
                  {productsListColumns.map((columnData, index) => {
                    if (columnData.key !== " ") {
                      return (
                        <td key={`${columnData.label} ${index}`}>{row}</td>
                      );
                    } else {
                      return (
                        <td
                          key={`${columnData.label} ${index}`}
                          onClick={() => deleteCurrentCategory(row)}
                        >
                          <button
                            className={
                              styles.productPageButtons + " " + styles.delButton
                            }
                          >
                            <FaTrash />
                          </button>
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <button
          className={styles.productPageButtons + " " + styles.addCategoryButton}
          onClick={addCategory}
        >
          Add New Category
        </button>
      </div>
      {showAddCategory && <AddNewCategory />}
    </section>
  );
};

export default ProductCatSection;
